import { featureFlags, FeatureFlag } from "./featureFlags";

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
